const isSSR = () => typeof window === "undefined";
export {
  isSSR
};
//# sourceMappingURL=is-ssr.js.map
